import styled from 'styled-components'
import { BREAKPOINTS } from '../../constants/breakpoints'

export const Title = styled.h1`
  margin-bottom: 20px;
  font-family: Ubuntu, sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 2px;
  text-align: center;
`

export const ContainerAddressSelected = styled.div`
  max-width: 800px;
  margin: auto;

  p {
    font-family: Ubuntu, sans-serif;
    font-weight: 500;
    font-size: 14px;
    color: #9f9f9f;
    margin: 0;
  }

  .search-container {
    max-width: 600px;
    margin: 44px auto;
  }
`

export const StandardContainerCheckbox = styled.div`
  max-width: 600px;
  margin: auto;
`

export const StandardContainer = styled.div`
  width: 100%;
  margin: auto;

  .DFcontainer {
    padding-left: 0;
  }
  .add-content {
    margin: auto;
    display: flex;
    width: 600px;
    justify-content: end;

    > div {
      padding: 0;
      margin: 0;
    }
  }

  div[mode='normal'] {
    max-width: 100%;
    padding-right: 0;

    button.submitButton {
      width: 100%;
      margin-left: 0;
      margin-right: 0;
    }
  }
`

export const RadioButtonContainer = styled.div`
  text-align: left;
  .DFradioFieldWrapper {
    span {
      > div {
        display: flex;
      }
    }
  }
  .DFradioField {
    label {
      text-align: left;
    }
  }
`

export const OwnerIdentificationContainer = styled.div`
  text-align: left;
  width: 100%;

  .full {
    width: 100%;

    .DFtextField {
      margin-left: 0;
    }
  }
`

export const UserInfoContainer = styled.div`
  background: white;
  margin: 20px 0px;
  padding: 20px;

  @media ${BREAKPOINTS.md} {
    padding: 20px 40px;
  }

  .info-container {
    width: 100%;

    @media ${BREAKPOINTS.lg} {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 32px;
    }

    > .row {
      margin: 10px 0px;
      width: 100% !important;

      @media ${BREAKPOINTS.md} {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
      }

      @media ${BREAKPOINTS.lg} {
        width: 50%;
      }

      p {
        font-family: Ubuntu, sans-serif;
        font-size: 16px;
        font-weight: 300;
        line-height: 14px;
        letter-spacing: 0.02em;
        text-align: left;
        color: #6e6e6e;
        margin: 0;
        margin-right: 10px;
      }

      span {
        font-family: Ubuntu, sans-serif;
        font-size: 16px;
        font-weight: 700;
        line-height: 14px;
        letter-spacing: 0.02em;
        text-align: left;
        color: #1f1f1f;
      }
    }
  }
`

export const BoxStyledContainer = styled.div`
  max-width: 600px;
  margin: auto;

  * {
    box-sizing: border-box;
  }

  .DFGreyBoxTitle {
    display: none;
  }
  .DFGreyBox {
    width: 100%;
    padding-left: 20px;
    padding-right: 20px;
  }
`
export const BoxStyled = styled.div`
  width: 100%;
`

export const DatePickerContainer = styled.div`
  .DFdatePicker {
    * {
      font-family: 'Ubuntu', sans-serif !important;
    }
  }
`

export const AdditionalContainer = styled.div`
  width: 100%;
  max-width: 600px;

  h2 {
    margin-bottom: 20px;
    font-family: Ubuntu, sans-serif;
    font-size: 18px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 2px;
    text-align: left;
  }

  .add-content {
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    > div {
      padding: 0;
    }
  }

  .legal-container {
    max-width: 600px;
    width: 100%;

    * {
      box-sizing: border-box;
    }
  }
`

export const ButtonSaveContainer = styled.div`
  margin: auto;
  display: flex;
  width: 600px;
  justify-content: end;

  .button-save {
    margin-left: auto;
    margin-top: 20px;
    button {
      margin: 0;
    }
  }
`
